<template>
    <p class="mb-0">
        <table class="table table-striped table-sm" v-if="calculationData">
            <thead>
                <tr>
                    <th style="width:10%">Datum</th>
                    <th>Projekt</th>
                    <th>Task</th>
                    <th style="width:10%" class="text-right">Timmar</th>
                </tr>
            </thead>   
            <tbody>
                <tr v-for="entry in calculationData.TimeEntries" :key="entry.id">
                    <td style="width:15%">{{entry.Spent | moment("YYYY-MM-DD")}}</td>
                    <td>{{entry.Project}}</td>
                    <td>{{entry.Task}}</td>
                    <td style="width:10%" class="text-right">{{entry.Hours}}</td>     
                </tr>       
            </tbody> 
            <tfoot>
                <tr>
                    <th colspan="3">Summa</th>
                    <td class="text-right"><strong>{{calculationData.TimeEntries.reduce((s, f) => s+f.Hours, 0)}}</strong></td>
                </tr>
            </tfoot>
        </table>
    </p>
</template>

<script>
export default {
  props: {
    calculationData: Object
  }
}
</script>

<style>

</style>
